import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: '[appAlignRightNumber]',
})
export class AlignRightNumberDirective implements OnInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    if (this.el.nativeElement.innerText === null) {
      return;
    }

    const innerText = this.el.nativeElement.innerText.trim();
    if (!isNaN(parseFloat(innerText))) {
      this.renderer.setStyle(this.el.nativeElement, 'text-align', 'right');
    }
  }
}
